import { render, staticRenderFns } from "./TwoFactorChallenge.vue?vue&type=template&id=24406602&"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js&"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports